export const apiRequest = async (url, method, body) => {
  try {
    const response = await fetch(url,
      {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
    if (response.status === 200 || response.status === 201) {
      return response.json();
    }
    throw Error(`${response.status} ${response.statusText}`);
  } catch (error) {
    throw error;
  }
};

export default apiRequest;
